/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KpiParameterAllowedValuesSourceDto } from './kpi-parameter-allowed-values-source-dto';
import { KpiParameterColumnDto } from './kpi-parameter-column-dto';


export interface KpiParameterDto { 
    /**
     * Must match a {{name}} placeholder in the SQL. timeGrain and dateRange parameters are referenced with a rendering modifier instead: {{name.unit}} (date_trunc unit, e.g. \'month\') and/or {{name.interval}} (interval literal, e.g. \'1 month\') for a timeGrain; {{name.from}} and/or {{name.to}} (inclusive date literals) for a dateRange.
     */
    name: string;
    /**
     * Value kind of the parameter, which decides how a supplied value is bound and escaped at execution time. column is a column-bound parameter (a Field Filter): {{name}} stands for a whole condition generated from the dashboard filter\'s operator and values, e.g. WHERE t.\"transaction_time\" >= {{period.from}} AND {{store}}; it renders 1 = 1 when there is no value. Declare its column in column.
     */
    type: KpiParameterDto.TypeEnum;
    /**
     * Whether a value must be supplied. An optional parameter falls back to its default. Defaults to false.
     */
    required?: boolean;
    /**
     * Default value bound when no value is supplied. dateRange parameters take a Metabase date string resolved server-side at query time (past30days~, previousmonth, thisyear, 2026-01-01~2026-03-31, 2026-03, Q1-2026, …); date parameters take a single day (YYYY-MM-DD, today or yesterday); timeGrain parameters take a TimeGrain value (daily…yearly).
     */
    defaultValue?: object;
    /**
     * text, enum and number only: the parameter takes several values. It renders as a typed array (ARRAY[\'a\',\'b\']::text[], ARRAY[1,2]::numeric[]; a single value as a one-element array) or NULL::text[] / NULL::numeric[] when empty, so the SQL must use it only as col = ANY({{name}}) or {{name}} IS NULL, e.g. AND ({{name}} IS NULL OR cr.\"usage_type\" = ANY({{name}})). Cast a non-text column in the predicate (t.\"store_id\"::text = ANY({{storeId}})). At most 100 values. A multi dashboard filter binds only to multiple parameters. Defaults to false.
     */
    multiple?: boolean;
    /**
     * column parameters only (required there): the column the generated condition filters, and its value kind.
     */
    column?: KpiParameterColumnDto;
    /**
     * Static option list for enum-like preview controls.
     */
    allowedValues?: Array<string>;
    /**
     * Read-only SQL source for dynamic preview options.
     */
    allowedValuesSource?: KpiParameterAllowedValuesSourceDto;
}
export namespace KpiParameterDto {
    export const TypeEnum = {
        Date: 'date',
        Enum: 'enum',
        Text: 'text',
        Number: 'number',
        TimeGrain: 'timeGrain',
        DateRange: 'dateRange',
        Column: 'column'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


